import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	documentTitle: {
		id: 'servicedesk-insight-object-schema-page.document-title',
		defaultMessage: 'Object Schema',
		description: 'Document title for the object schema page.',
	},
});
